import { render, staticRenderFns } from "./modalSenhaServidor.vue?vue&type=template&id=1a67e94d&scoped=true&"
import script from "./modalSenhaServidor.vue?vue&type=script&lang=js&"
export * from "./modalSenhaServidor.vue?vue&type=script&lang=js&"
import style0 from "./modalSenhaServidor.vue?vue&type=style&index=0&id=1a67e94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67e94d",
  null
  
)

export default component.exports